/*eslint-disable */

import 'vue-datetime/dist/vue-datetime.css'

import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect'
import Vue from "vue";
import axios from 'axios';
import { bus } from '@/main';
import createMeetingInfoPopup from '@/components/create-meeting-info-popup';
import { mapGetters } from 'vuex';
import moment from 'moment';
import removeMeetingPopup from '@/components/meeting-remove-popup';
import root from '@/_helpers/roots';
import toast from '@/services/toast';
import updateMeeting from '@/components/update-meeting-details';

var $ = window.jQuery = require('jquery');
var interval;
// You need a specific loader for CSS files
Vue.component('multiselect', Multiselect)
let getAllMeetingListURL = root.getAllMeetingListUrl.link;
export default {
  name: 'create-meeting-list',
  components: {
    datetime: Datetime,
    Multiselect,
    'edit-meeting' : updateMeeting,
    'create-meeting' : createMeetingInfoPopup,
    'remove-meeting' : removeMeetingPopup,
  },
  props: [],
  data () {
    return {
      createMeetingPopup:false,
      userProfileDetails:null,
      meetingListDetails:null,
      curentDate: new Date(),
      currentUTCDate: '',
      selfUserId:'',
      editMeetingId:'',
      updateMeetingPopup:false,
      countDownMinutes:'',
      countDownSecond:'',
      counterText:'',
      nextPageUrl:'',
      nextSteper:'',
      meetingListResults:[],
      loadmoreData:'',
      userLoading:false,
      removeMeetingPopup:false,
      removeMeetingId:'',
      StaticUUID:'6d5e0cc3-a9d8-4f18-99dc-b5a45d194a52695872',
      is_public:false,
      domainLocationOrigin:process.env.VUE_APP_PUBLIC_URL,
      minDatetime:new Date().toISOString(),
      filterType:'',
      yearState:'',
      monthState:'',
      monthStateVal:'',
      meetingCheckState:'',
      filterEnabledState:false,
      isMobile:false
    }
  },
  computed: {
  ...mapGetters([
    'acUserDetailsStateGetters',
    'getMeetingListGetters'
  ]),
  getUserDetailsInfo(){
    this.userProfileDetails = this.$store.getters.acUserDetailsStateGetters.data;
    return
  },
  getMeetingList(){
    this.meetingListDetails = this.$store.getters.getMeetingListGetters.data;
    return
  },
  getMeetingIntialState(){
    if(this.meetingListDetails){
      this.nextPageUrl = this.meetingListDetails.next
      this.nextSteper = this.meetingListDetails.next
      this.meetingListResults = [].concat(this.meetingListDetails.results)
    }
  },
  },
  mounted () {
    if(localStorage.getItem('LoginedUserID')){
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
    this.getUserDetailsInfo
    this.getMeetingList
    this.getMeetingIntialState
    bus.$on('updateMeetingStateBus', (data) => {
      this.updateMeetingPopup = data;
    });
    bus.$on('removeMeetingPopupBus', (data) => {
      this.removeMeetingPopup = data;
    });
    bus.$on('createMeetingPopupBus', (data) => {
      this.createMeetingPopup = data;
    });
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 1023
    },
    clearFiltersMethod(){
      this.filterEnabledState = false
      this.filterType = ''
      this.monthState = ''
      this.monthStateVal = ''
      this.meetingCheckState = ''
      this.yearState = ''
      this.userLoading = true
      this.$store.dispatch('getMeetingAllListFun').then((res) => {
        this.userLoading = false
      }).catch((err) => {
        this.userLoading = false
      })
    },
    filterByKeyMethod(val){
      this.filterEnabledState = true
      this.filterType = val
      this.userLoading = true
      if(this.filterType == 'upcoming'){
        this.meetingCheckState = 'True'
      }else{
        this.meetingCheckState = 'False'
      }
      axios.get(getAllMeetingListURL + '?is_webinar=False' + '&page_size=15' + '&upcoming=' + this.meetingCheckState + '&date_time=' + moment(new Date()).format() + '&year=' + this.yearState + '&month=' + this.monthStateVal).then((response) => {
        this.meetingListDetails = response.data.data
        this.nextPageUrl = this.meetingListDetails.next
        this.nextSteper = this.meetingListDetails.next
        this.meetingListResults = [].concat(this.meetingListDetails.results)
        this.userLoading = false
      })
    },
    filterByYearMethod(val){
      this.filterEnabledState = true
      this.yearState = val
      this.userLoading = true
      axios.get(getAllMeetingListURL + '?is_webinar=False' + '&page_size=15' + '&upcoming=' + this.meetingCheckState + '&year=' + this.yearState + '&month=' + this.monthStateVal).then((response) => {
        this.meetingListDetails = response.data.data
        this.nextPageUrl = this.meetingListDetails.next
        this.nextSteper = this.meetingListDetails.next
        this.meetingListResults = [].concat(this.meetingListDetails.results)
        this.userLoading = false
      })
    },
    filterByMonthMethod(month, val){
      this.filterEnabledState = true
      this.monthState = month
      this.monthStateVal = val
      this.userLoading = true
      const is_year = this.yearState || moment(new Date()).format('YYYY')
      axios.get(getAllMeetingListURL + '?is_webinar=False' + '&page_size=15' + '&upcoming=' + this.meetingCheckState + '&year=' + is_year + '&month=' + this.monthStateVal).then((response) => {
        this.meetingListDetails = response.data.data
        this.nextPageUrl = this.meetingListDetails.next
        this.nextSteper = this.meetingListDetails.next
        this.meetingListResults = [].concat(this.meetingListDetails.results)
        this.userLoading = false
      })
    },
    userReminderForMeetingMethod(item){
      let payload = {
        id:item.id
      }
      this.$store.dispatch('meetingReminderAction', payload).then((res) => {
        toast.success(res.data.msg);
      })
    },
    urlClipBoardMethod(value) {
      const copyUrl = this.domainLocationOrigin + '/public/meeting/#' + value
      navigator.clipboard.writeText(copyUrl);
    },
    showLoadMoreDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.nextSteper = response.data.data.next
          this.meetingListResults = [].concat(response.data.data.results, this.meetingListResults);
          this.userLoading = false
        });
    },
    updateMeetingMethod(meetingId){
      this.editMeetingId = meetingId
      this.updateMeetingPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    startCountdownTimer(joinStartTime, meetingId){
      var currentLocalDate = moment().format('MMMM Do YYYY');
      var startDateCheck = moment(joinStartTime).format('MMMM Do YYYY')
      var currentLocalHours = moment().format('HH')
      var currentLocalTime = moment().format('mm:ss')
      var currentLocalSec = moment().format('ss')
      var startTimeHours = moment(joinStartTime).format('HH')
      var startTimeCheck = moment(joinStartTime).format('mm:ss')
      var startTimeSec = moment(joinStartTime).format('mm:ss')
      if(startDateCheck === currentLocalDate){
          var totalMinutesOfStartMeeting  = startTimeHours*parseInt(60) + parseInt(startTimeCheck);
          var totalMinutesOfCurrent  = currentLocalHours*parseInt(60) + parseInt(currentLocalTime);
          if(totalMinutesOfStartMeeting > totalMinutesOfCurrent){
            var validTime = totalMinutesOfStartMeeting - totalMinutesOfCurrent
            // console.log(validTime, "Checking Hours to Mint")
            if(parseInt(11) > validTime){
              this.counterText = validTime + ':' + '00';
              this.countdownTimer(meetingId)
              return this.counterText;
            }else{
              return false;
            }
          }else{
            return false;
          }
      }else{
        return false;
      }
    },
    countdownTimer(meetingID) {
      var __self = this
      clearInterval(interval);
      interval = setInterval( function() {
          var timer = $('#timeout' + meetingID).html();
          timer = timer.split(':');
          var minutes = timer[0];
          var seconds = timer[1];
          seconds -= 1;
          if (minutes < 0) return;
          else if (seconds < 0 && minutes != 0) {
              minutes -= 1;
              seconds = 59;
          }
          else if (seconds < 10 && length.seconds != 2) seconds = '0' + seconds;
          $('#timeout' + meetingID).html(minutes + ':' + seconds);
          if (minutes == 0 && seconds == 0){
            __self.getMeetingListAgain()
            clearInterval(interval)
          };
      }, 1000);
    },
    enabledJoinBtn(joinStartTime, joinEndTime) {
      var startDateTimeUTC = moment(joinStartTime).local().format();
      var endDateTimeUTC = moment(joinEndTime).local().format();
      var curentDateUTC = moment().local().format();
      if (curentDateUTC > startDateTimeUTC && endDateTimeUTC > curentDateUTC){
        return true;
      }else{   
        return false;
      }
    },
    statusCheckOfMeetingMethod(endTime){
      var startTime2 = moment(endTime).local().format();
      var curentDateUTC = moment().local().format();
      if (startTime2 > curentDateUTC){
        return true;
      }else{   
        return false;
      }
    },
    getMeetingListAgain(){
      this.$store.dispatch('getMeetingAllListFun').then((res)=>{
        this.meetingListDetails = res.data.data
      })
    },
    openCreateMeetingPopup(){
      this.createMeetingPopup = true
      document.body.classList.add('body_right_scroll_remove')
    },
    removeMeetingMethod(removeItemId){
      this.removeMeetingPopup = true
      this.removeMeetingId = removeItemId
      document.body.classList.add('body_right_scroll_remove')
    },
  },
  watch: {
    getUserDetailsInfo(){
      return this.$store.getters.acUserDetailsStateGetters
    },
    getMeetingList(){
      return this.$store.getters.getMeetingListGetters
    },
    getMeetingIntialState(){
      if(this.meetingListDetails){
        this.nextPageUrl = this.meetingListDetails.next
        this.meetingListResults = [].concat(this.meetingListDetails.results)
      }
    },
    nextSteper(old_val, new_val){
      if(old_val != ''){
        this.nextPageUrl = old_val
      }
    },
  },
  beforeRouteLeave: function(to, from, next) {
    next();
  },
  created () {
    window.addEventListener('resize', this.onResize, { passive: true })
    this.onResize()
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  beforeDestroy() {
    clearInterval(interval);
  },
}